import React from 'react'

import Subtitle from '../../../components/Subtitle'
import withFetch from '../../../infrastructure/withFetch'
import KeyMetricsWidget from '../components/KeyMetricsWidget'
import KeyMetricsSales from './KeyMetricsSales'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/sales/get-customers-by-date/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry, event }) => {
        return (
            <KeyMetricsWidget data={data} status={status} retry={retry}>
                <KeyMetricsSales data={data} event={event} />
            </KeyMetricsWidget>
        )
    },
)

const tooltip = (
    <div>
        <p>
            Click on each option (Sales, Sales Value, % Sold) to change graph.
            Sales is tickets sold.
        </p>
        <p>Hover mouse over chart plot line to see value for each day.</p>
        <p>
            Small number under Sales/Sales Value totals is for sales/sales value
            today (since Midnight, venue time).
        </p>
    </div>
)

const GetSalesWidget = ({ eventId, startDate, endDate, event }) => (
    <div>
        <Subtitle title="Sales Trend" tooltip={tooltip} />
        <Chart eventId={eventId} startDate={startDate} endDate={endDate} event={event} />
    </div>
)

export default GetSalesWidget
